import React from 'react'
import { BtnComponent, IconComponent, PopoverComponent, UITrigger } from 'LibNeo'
import {
	hasInIconLibrary,
	InterfaceElementModel,
	interfaceElementSlice,
	SvgLibrary,
} from 'Pages/interfaceElement'
import { Icon } from 'antd'
import { useAppDispatch } from 'Src/hooks'
import { isEmptyValue } from 'Helpers'

interface ComponentProps {
	item: InterfaceElementModel
}

const actions = {
	updateIE: interfaceElementSlice.actions.updateOne,
}

export const CustomColumnIconComponent: React.FC<ComponentProps> = ({ item }): JSX.Element => {
	const { updateIE } = useAppDispatch(actions)
	const onClickIcon = (value) =>
		updateIE({ interfaceElement: { ...item, icon: value }, id: item.id })
	return (
		<PopoverComponent
			title={null}
			content={
				<div>
					{SvgLibrary.result.map(
						(icon: string): JSX.Element => (
							<BtnComponent
								icon={icon}
								key={icon}
								tooltip={icon}
								onClick={() => onClickIcon(icon)}
								link
							/>
						)
					)}
				</div>
			}
			trigger={UITrigger.CLICK}
		>
			{hasInIconLibrary(item?.icon) ? (
				<IconComponent name={item?.icon} />
			) : (
				<Icon
					component={() => (
						<i className={`fa ${isEmptyValue(item?.icon) ? 'fa-desktop' : item?.icon}`} />
					)}
				/>
			)}
		</PopoverComponent>
	)
}

export const CustomColumnIcon = React.memo<ComponentProps>(CustomColumnIconComponent)
